import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { CompatRouter } from "react-router-dom-v5-compat";
import App from "./components/app/App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <React.StrictMode>
        <BrowserRouter basename={"/app"}>
            <CompatRouter>
                <App />
            </CompatRouter>
        </BrowserRouter>
    </React.StrictMode>
);
